import { ColumnsConf } from '../../../orders/work-items/columns/columns-conf'
import { I18nText } from '@elderbyte/ngx-starter'
import { ItemSortSpec } from '../../../shopfloor/workcenters/types/items/item-sort-spec'
import { ProductionListPropertyDefinition } from '../../../orders/work-items/properties/production-list-property-definition'
import { ProductionListScope } from './prod-list-scope'

export class ProductionListConf {
  constructor(
    public id: string,
    public scope: ProductionListScope,
    public nameI18n: I18nText[],
    public templateId: string,
    public distinctProperties: ProductionListPropertyDefinition[],
    public columnsConf: ColumnsConf,
    public itemSortSpec: ItemSortSpec,
    public resolveMaterialList: boolean,
    public aggregateMaterials: boolean
  ) {}
}
